import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "icon-arrow",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "M12 1.25c5.93 0 10.75 4.82 10.75 10.75S17.93 22.75 12 22.75 1.25 17.93 1.25 12 6.07 1.25 12 1.25m0 20c5.1 0 9.25-4.15 9.25-9.25S17.1 2.75 12 2.75 2.75 6.9 2.75 12 6.9 21.25 12 21.25" }),
      _createElementVNode("path", { d: "M8.5 11.25h6c.41 0 .75.34.75.75s-.34.75-.75.75h-6c-.41 0-.75-.34-.75-.75s.34-.75.75-.75" }),
      _createElementVNode("path", { d: "M12.5 8.25c.19 0 .38.07.53.22l3 3c.29.29.29.77 0 1.06l-3 3c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06L14.44 12l-2.47-2.47a.754.754 0 0 1 0-1.06c.15-.15.34-.22.53-.22" })
    ], -1)
  ]))]))
}
export default { render: render }